var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_1725_1973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5398 10.8514C20.4742 10.8514 20.4185 10.8382 20.3725 10.812C20.3266 10.7858 20.2905 10.74 20.2643 10.6744L19.6936 9.33757L18.2569 8.70847C18.1913 8.68225 18.1454 8.64621 18.1192 8.60034C18.0929 8.55447 18.0798 8.49877 18.0798 8.43323C18.0798 8.3677 18.0929 8.312 18.1192 8.26613C18.1454 8.22026 18.1913 8.18421 18.2569 8.158L19.6936 7.54856L20.2643 6.27069C20.2905 6.20515 20.3266 6.15928 20.3725 6.13307C20.4185 6.10686 20.4742 6.09375 20.5398 6.09375C20.6054 6.09375 20.6612 6.10686 20.7071 6.13307C20.753 6.15928 20.7891 6.20515 20.8153 6.27069L21.386 7.54856L22.8227 8.158C22.8883 8.18421 22.9342 8.22026 22.9604 8.26613C22.9867 8.312 22.9998 8.3677 22.9998 8.43323C22.9998 8.49877 22.9867 8.55447 22.9604 8.60034C22.9342 8.64621 22.8883 8.68225 22.8227 8.70847L21.386 9.33757L20.8153 10.6744C20.7891 10.74 20.753 10.7858 20.7071 10.812C20.6612 10.8382 20.6054 10.8514 20.5398 10.8514ZM20.5398 22.5684C20.4873 22.5684 20.4349 22.5553 20.3824 22.5291C20.3299 22.5029 20.2905 22.457 20.2643 22.3915L19.6936 21.1136L18.2766 20.5042C18.211 20.478 18.1651 20.4419 18.1389 20.3961C18.1126 20.3502 18.0995 20.2945 18.0995 20.229C18.0995 20.1634 18.1126 20.1077 18.1389 20.0618C18.1651 20.016 18.211 19.9799 18.2766 19.9537L19.6936 19.3443L20.2643 17.9878C20.2905 17.9222 20.3266 17.8764 20.3725 17.8501C20.4185 17.8239 20.4742 17.8108 20.5398 17.8108C20.6054 17.8108 20.6612 17.8239 20.7071 17.8501C20.753 17.8764 20.7891 17.9222 20.8153 17.9878L21.386 19.3443L22.803 19.9537C22.8686 19.9799 22.9145 20.016 22.9408 20.0618C22.967 20.1077 22.9801 20.1634 22.9801 20.229C22.9801 20.2945 22.967 20.3502 22.9408 20.3961C22.9145 20.4419 22.8686 20.478 22.803 20.5042L21.386 21.1136L20.8153 22.3915C20.7891 22.457 20.7497 22.5029 20.6973 22.5291C20.6448 22.5553 20.5923 22.5684 20.5398 22.5684ZM11.9003 19.1673C11.7953 19.1673 11.6937 19.1378 11.5953 19.0789C11.4969 19.0199 11.4214 18.938 11.369 18.8331L10.0898 16.1004L7.33456 14.8619C7.2296 14.8095 7.1476 14.7341 7.08856 14.6358C7.02952 14.5375 7 14.4359 7 14.3311C7 14.2262 7.02952 14.1247 7.08856 14.0264C7.1476 13.9281 7.2296 13.8527 7.33456 13.8003L10.0898 12.5617L11.369 9.84872C11.4214 9.73076 11.4969 9.64229 11.5953 9.58332C11.6937 9.52434 11.7953 9.49485 11.9003 9.49485C12.0053 9.49485 12.1069 9.52434 12.2053 9.58332C12.3037 9.64229 12.3792 9.72421 12.4317 9.82906L13.7305 12.5617L16.4661 13.8003C16.5841 13.8527 16.6727 13.9281 16.7317 14.0264C16.7908 14.1247 16.8203 14.2262 16.8203 14.3311C16.8203 14.4359 16.7908 14.5375 16.7317 14.6358C16.6727 14.7341 16.5841 14.8095 16.4661 14.8619L13.7305 16.1004L12.4317 18.8331C12.3792 18.9511 12.3037 19.0363 12.2053 19.0887C12.1069 19.1411 12.0053 19.1673 11.9003 19.1673Z",
    fill: "url(#paint0_linear_1725_1973)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_1725_1973",
    x: 0.633232,
    y: 0.531976,
    width: 28.0017,
    height: 29.576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.31726,
    dy: 2.48816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52475
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1725_1973"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24408,
    dy: -1.1709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.19544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1725_1973",
    result: "effect2_dropShadow_1725_1973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1725_1973",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9393
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1725_1973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1725_1973",
    x1: 17.7967,
    y1: 13.8484,
    x2: 15.3181,
    y2: 25.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/bot-icon.858cb3e357e4468082aba7af2134ab63.svg";
export { ForwardRef as ReactComponent };